import { Component } from 'react';
import {
    FormControl,
    MenuItem,
    Select,
    InputLabel,
} from '@mui/material';

import { getAllowedGroupSizes } from "../utils/RuleLogic";

class GroupSizeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { value: '' }; // Ensure it's an empty string initially
        this.id = props.id;
    }

    handleGroupSizeSelect(e) {
        this.setState({ value: e.target.value });
        this.props.handleGroupSize(e); // Call the parent's handler if necessary
    }

    render() {
        const allowedSizes = getAllowedGroupSizes(this.props.playerCount);

        
        // Check for the value in allowed sizes
        const isValidValue = allowedSizes.length > 0 
        const valueToDisplay = isValidValue ? this.props.groupSize : '';

        return (
            <FormControl fullWidth sx={{ width: '90%', mt: 2 }} disabled={!isValidValue}>
                <InputLabel id="group-size-label">Group Size</InputLabel>
                <Select
                    labelId={`group-select-${this.id}`}
                    id={`group-select-${this.id}`}
                    value={valueToDisplay} // Ensure we are displaying a valid value
                    label="Group Size"
                    displayEmpty
                    variant='outlined'
                    onChange={(event) => this.handleGroupSizeSelect(event)}
                    
                >
                        <MenuItem value={"-"} key='placeholder-index' sx={{display: 'none'}}/>
                    {allowedSizes.map((value, index) => (
                        <MenuItem value={value} key={`player-${this.id}-groupsize-key-${index + 1}`}>
                            {value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }
}

export default GroupSizeSelect;
